import React from "react";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import { Route } from "react-router-dom";
import {
  GJS_HOMEPAGE_BUILDER_ROUTE_IDS,
  GJS_HOMEPAGE_BUILDER_ROUTE_KEYS,
} from "./HomepageBuilder.constants";

const GJSHomepageBuilder = React.lazy(() =>
  import("../GJSHomepageBuilder").then((m) => ({
    default: m.GJSHomepageBuilder,
  }))
);

const StorefrontHomepageRedirect = React.lazy(() =>
  import("../modules/StorefrontHomepageRedirect/StorefrontHomepageRedirect")
);

export const GJS_HOMEPAGE_BUILDER_CUSTOM_ROUTES = [
  <Route
    exact
    key={GJS_HOMEPAGE_BUILDER_ROUTE_IDS[GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]}
    path={
      GJS_HOMEPAGE_BUILDER_ROUTE_IDS[GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]
    }
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={GJSHomepageBuilder} />
    )}
    noLayout
  />,
  <Route
    exact
    key={
      GJS_HOMEPAGE_BUILDER_ROUTE_IDS[
        GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.storefront_homepage
      ]
    }
    path={
      GJS_HOMEPAGE_BUILDER_ROUTE_IDS[
        GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.storefront_homepage
      ]
    }
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={StorefrontHomepageRedirect} />
    )}
    noLayout
  />,
];
